import React from 'react';
import { Share2, Trash2 } from 'lucide-react';
import { MonitorButton, MonitorButtonRef } from '../monitoring/MonitorButton';
import { ExportDropdown } from './ExportDropdown';

export interface DatasetHeaderProps {
  tableName: string;
  leadCount: number;
  tableId: string;
  websetId?: string;
  monitorButtonRef: React.RefObject<MonitorButtonRef>;
  exportMenuRef: React.RefObject<HTMLDivElement>;
  showExportMenu: boolean;
  onToggleExportMenu: () => void;
  onCloseExportMenu: () => void;
  onShare: () => void;
  onExportCSV: () => void;
  onExportExcel: () => void;
  onDelete: () => void;
  onStartMonitorSetup: () => void;
}

export const DatasetHeader: React.FC<DatasetHeaderProps> = ({
  tableName,
  leadCount,
  tableId,
  websetId,
  monitorButtonRef,
  exportMenuRef,
  showExportMenu,
  onToggleExportMenu,
  onCloseExportMenu,
  onShare,
  onExportCSV,
  onExportExcel,
  onDelete,
  onStartMonitorSetup,
}) => {
  return (
    <div className="h-16 flex items-center justify-between px-4 border-b border-gray-200 bg-white flex-shrink-0">
      <div className="flex items-baseline gap-3 min-w-0 flex-1 mr-3">
        <h2 className="text-[15px] font-semibold text-gray-900 truncate min-w-0 leading-none">
          {tableName || 'Dataset'}
        </h2>
        <span className="text-[12px] text-gray-400 font-medium whitespace-nowrap flex-shrink-0 leading-none">
          {leadCount} results
        </span>
      </div>
      <div className="flex items-center gap-0.5">
        <MonitorButton
          ref={monitorButtonRef}
          tableId={tableId}
          tableName={tableName || 'Dataset'}
          websetId={websetId}
          onStartChatSetup={onStartMonitorSetup}
        />
        <button
          id="dataset-share-btn"
          onClick={onShare}
          className="flex items-center gap-1.5 px-2.5 py-1.5 text-[12px] font-medium text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
          title="Share"
        >
          <Share2 className="w-4 h-4" />
          Share
        </button>
        <ExportDropdown
          ref={exportMenuRef}
          isOpen={showExportMenu}
          onToggle={onToggleExportMenu}
          onClose={onCloseExportMenu}
          onExportCSV={onExportCSV}
          onExportExcel={onExportExcel}
        />
        <button
          onClick={onDelete}
          className="p-2 text-gray-400 hover:text-red-500 hover:bg-gray-100 rounded-md transition-colors"
          title="Delete"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
